<template>
  <div>
    <app-board :header="false" class="p-3 mb-3">
      <moduleForm
          :bindingForView="true"
          :dataToBind="entityDataToBind"
          :edit-mode="true"
          :onCreateCallback="false"
          :showPasswordField="false"
          formTitle="Profile"></moduleForm>
    </app-board>

    <changePassword></changePassword>
  </div>
</template>

<script>
export default {
  data() {
    return {
      entityDataToBind: $store.state['user-state'].profile
    }
  },
  components: {
    moduleForm: () => import('./../form/View.vue'),
    changePassword: () => import('./../security/ChangePassword.vue')
  }
}
</script>
